if (!window.customElements.get("discount-countdown")) {
  var DiscountCountdown = class extends HTMLElement {
    constructor() {
      super();
      try {
        // 1. 安全获取属性
        this._endingTime = this.getAttribute("data-ending-time") || '';
        
        // 2. 安全获取DOM元素（带默认值）
        this._elements = {
          day: this.querySelector("[data-countdown-day]"),
          hour: this.querySelector("[data-countdown-hour]"),
          minute: this.querySelector("[data-countdown-minute]"),
          seconds: this.querySelector("[data-countdown-seconds]")
        };
        
        // 3. 初始化默认显示 - 修改：默认隐藏
        this._initDefaultDisplay();
        
      } catch (error) {
        console.error('DiscountCountdown init error:', error);
      }
    }

    connectedCallback() {
      clearInterval(this._interval);

      if (!this._validateElements()) {
        console.warn('DiscountCountdown: Required elements missing');
        return;
      }

      if (!this._validateTime()) {
        this._showError('Invalid time format');
        return;
      }

      // 首次立即显示；已结束的倒计时不再创建定时器。
      this._handleCountdown();

      if (new Date(this._endingTime).getTime() - Date.now() >= 1000) {
        this._interval = setInterval(
          this._handleCountdown.bind(this),
          1000
        );
      }
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    // 6. 元素验证方法
    _validateElements() {
      return Object.values(this._elements).every(el => el instanceof HTMLElement);
    }

    // 7. 时间验证方法
    _validateTime() {
      return !isNaN(new Date(this._endingTime).getTime());
    }

    // 8. 初始化默认显示 - 修改：默认隐藏整个组件
    _initDefaultDisplay() {
      Object.values(this._elements).forEach(el => {
        if (el) el.textContent = '00';
      });
      // 默认隐藏
      this._toggleDisplay(false);
    }

    // 9. 显示错误信息
    _showError(message) {
      console.error(message);
      this._initDefaultDisplay();
      this.style.color = 'red';
    }

    _formatNumber(num) {
      // 始终返回字符串，避免与 textContent 比较时重复写入。
      return String(num).padStart(2, '0');
    }

    // 检查是否所有时间都为0
    _isAllZero(day, hours, minutes, seconds) {
      return day === 0 && hours === 0 && minutes === 0 && seconds === 0;
    }

    // 显示/隐藏组件
    _toggleDisplay(show) {
      const parent = this.parentElement;
      if (!parent) return;

      const display = show ? '' : 'none';

      // 显示状态没有变化时，不重复写入 style。
      if (parent.style.display !== display) {
        parent.style.display = display;
      }
    }

    _handleCountdown() {
      try {
        const targetTime = new Date(this._endingTime).getTime();
        const currentTime = Date.now();
        const diffTime = targetTime - currentTime;

        const day = Math.floor(diffTime / 86400000);
        const hours = Math.floor((diffTime % 86400000) / 3600000);
        const minutes = Math.floor((diffTime % 3600000) / 60000);
        const seconds = Math.floor((diffTime % 60000) / 1000);

        // 10. 倒计时结束处理 - 修改：检查是否所有时间为0
        if (diffTime <= 0 || this._isAllZero(day, hours, minutes, seconds)) {
          this._initDefaultDisplay();
          this.dispatchEvent(new Event('countdown-end'));
          clearInterval(this._interval);
          return;
        }

        // 11. 安全更新DOM - 修改：添加显示逻辑
        const updateIfValid = (el, value) => {
          if (el && el.textContent !== value) {
            el.textContent = value;
          }
        };

        // 如果之前是隐藏的，现在显示出来
        this._toggleDisplay(true);

        updateIfValid(this._elements.day, this._formatNumber(day));
        updateIfValid(this._elements.hour, this._formatNumber(hours));
        updateIfValid(this._elements.minute, this._formatNumber(minutes));
        updateIfValid(this._elements.seconds, this._formatNumber(seconds));

      } catch (error) {
        console.error('Countdown error:', error);
        clearInterval(this._interval);
      }
    }
  };

  window.customElements.define("discount-countdown", DiscountCountdown);
}
